<!--
* @description  参数1
* @fileName  detailEdit
* @author userName
* @date 2024-01-02 14:56:30
!-->
<template>
  <div id="detailEdit" class="detailEdit">
    <DialogEidt :value="isShow" @close="closeDialog">
      <template v-slot:title>
        <div>修改信息</div>
      </template>
      <template v-slot:body>
        <div class="main-info p24 check-price-form">
          <el-form
            ref="formData"
            :model="formData"
            :rules="allRules"
            label-position="top"
            size="medium"
            class="item-Surcharge"
            @submit.native.prevent
          >
            <div class="new_inquiry_header item-Surcharge_search">
              <el-form-item class="flex-width_1" prop="userName" label="姓名">
                <el-input v-model="formData.userName" />
              </el-form-item>
              <el-form-item class="flex-width_1" prop="customerName" label="公司名称">
                <el-input v-model="formData.customerName" disabled />
              </el-form-item>
              <el-form-item class="flex-width_1" prop="mobilePhone" label="联系电话">
                <el-input v-model="formData.mobilePhone" />
              </el-form-item>
            </div>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <div class="foot-class">
          <button class="cancel" @click="closeDialog">取消</button>
          <button class="save by-button--primary" :loading="btnLoading" @click="clickSave">保存</button>
        </div>
      </template>
    </DialogEidt>
  </div>
</template>

<script>
import DialogEidt from '../../../components/Dialog/Dialog.vue'
import { GetCurrCustomer } from '@/api/user'
import request from '@/utils/request'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'DetailEdit',
  components: {
    // 组件的引用
    DialogEidt
  },
  props: {
    // 父辈向子辈传参
    isShow: {
      type: Boolean,
      default: () => {
        return false
      }
    }
  },
  data() {
    // var checkEmpty = (rule, value, callback) => {
    //   if (rule.required === false) {
    //     callback()
    //     return false
    //   }
    //   if (!value) {
    //     if (rule.fullField == 'StartCityKey') {
    //       console.log('====isCol1', rule, value, callback, this)
    //       this.isCol1 = true
    //     } else {
    //       this.isCol1 = false
    //     }

    //     document.documentElement.scrollTop = 0
    //     return callback(new Error('Please enter name'))
    //   } else {
    //     callback()
    //   }
    // }
    return {
      formData: {
        id: '',
        realName: '',
        customerName: '',
        mobilePhone: '',
        userName: ''
      },
      token: '',
      btnLoading: false,
      allRules: {
        userName: [{
          required: true,
		  message: '请输入联系人姓名'
        }
        ],
        mobilePhone: [{
          pattern: /^(\+)([0-9]{1,3})(\s)([0-9]{3,11})$/,
          message: '请输入正确的手机号'
        }]
      }
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    this.token = getCookie('token')
    if (this.token) {
      this.getCustomerInfo()
    }
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    getCustomerInfo() {
      GetCurrCustomer().then(res => {
		  if (res.code === 200) {
		    this.formData = res.data
		  }
      })
    },
    closeDialog() {
      this.$emit('close', false)
    },
    clickSave() {
      // 表单校验
      this.$refs['formData'].validate((val) => {
        if (val) {
          this.formData.realName = this.formData.userName
          request({
            url: '/api/webapi/User/Personal/' + this.formData.id,
            method: 'PUT',
            data: this.formData,
            headers: {
              Authorization: this.token
            }
          }).then((res) => {
            this.$message({
              message: res.msg,
              type: 'success',
              duration: 1000,
              onClose: () => {
                this.btnLoading = false
                this.closeDialog()
                this.$emit('refresh', true)
              }
            })
          }).finally(() => {
            this.btnLoading = false
          })
        }
      })
    }
  }
}
</script>
<style scoped lang='scss'>
	::v-deep .dialog__header {
		text-align: left;
	}

	::v-deep .dialog__body {
		padding: 0;

		.el-form-item {
			margin-bottom: 0;

			.el-form-item__label {
				float: left;
			}
		}
	}

	::v-deep .el-form-item__error {
		display: block !important;
	}

	.foot-class {
		margin: 24px 0;
		padding-bottom: 24px;
		text-align: right;

		.cancel {
			width: 72px;
			height: 32px;
			background: #ffffff;
			border-radius: 4px;
			border: 1px solid #dddddd;
			font-size: 14px;
			font-family: PingFangSC, PingFang SC;
			font-weight: 500;
			color: #333333;
			margin-right: 16px;
			cursor: pointer;
		}

		.save {
			width: 72px;
			height: 32px;
			border-radius: 4px;
			cursor: pointer;
		}
	}
</style>
